







































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'

import dayjs from "dayjs";

class PageLotteryRecordsRequest extends PageRequest {
  userId: string = '';
  campaignCode: string = '';
  packageCode: string = '';
  giftCode: any;
  endTime: any;
  startTime: any;
}

@Component({
  components: {}
})
export default class LotteryRecordsVM extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  pageRequest: PageLotteryRecordsRequest = new PageLotteryRecordsRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;

  get list() {
    return this.$store.state.lotteryRecords.list;
  };

  get loading() {
    return this.$store.state.lotteryRecords.loading;
  }

  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit('lotteryRecords/setCurrentPage', page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit('lotteryRecords/setPageSize', pagesize);
    this.getpage();
  }

  async getpage() {
    if (this.pageRequest.startTime) {
      this.pageRequest.startTime = dayjs(this.pageRequest.startTime).format('YYYY-MM-DD');
    }
    if (this.pageRequest.endTime) {
      this.pageRequest.endTime = dayjs(this.pageRequest.endTime).format('YYYY-MM-DD 23:59:59');
    }
    this.pageRequest.maxResultCount = this.pageSize;
    this.pageRequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: 'lotteryRecords/getAll',
      data: this.pageRequest
    })
  }

  get pageSize() {
    return this.$store.state.lotteryRecords.pageSize;
  }

  get totalCount() {
    return this.$store.state.lotteryRecords.totalCount;
  }

  get currentPage() {
    return this.$store.state.lotteryRecords.currentPage;
  }

  columns = [
    {
      title: this.L('ID'),
      key: 'id'
    },
    {
      title: this.L('抽奖人'),
      key: 'userid'
    },
    {
      title: this.L('活动代码'),
      key: 'campaignCode'
    }, {
      title: this.L('礼包代码'),
      key: 'packageCode'
    }, {
      title: this.L('奖品代码'),
      key: 'giftCode'
    }, {
      title: this.L('时间'),
      key: 'createTime'
    }, {
      title: this.L('返回值'),
      key: 'returnMsg'
    }]

  async created() {
    await this.getpage();

  }
}
